import {
  ObjectRelation,
  ObjectType,
} from "web/features/permissions/permissionsApiSlice";
import usePermission from "web/utils/usePermission";

const useCheckIfDashboardIsEnabled = (): boolean =>
  usePermission({
    objectId: "DASHBOARD",
    objectType: ObjectType.MODULE,
    objectRelation: ObjectRelation.HAS_ACCESS,
  });

export default useCheckIfDashboardIsEnabled;
